import { Link } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/resources';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
                {siteInfo.name}
              </h4>
              <p className="text-sm text-secondary-200 leading-relaxed">
                {siteInfo.description.slice(0, 80)}...
              </p>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-200 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="邮箱">
                  <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">资源分类</h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-200 hover:text-primary-300 transition-colors duration-200 cursor-pointer">
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">快捷链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-secondary-200 hover:text-primary-300 transition-colors duration-200 cursor-pointer">首页</Link></li>
                <li><Link to="/category/study" className="text-sm text-secondary-200 hover:text-primary-300 transition-colors duration-200 cursor-pointer">学习资源</Link></li>
                <li><Link to="/category/office" className="text-sm text-secondary-200 hover:text-primary-300 transition-colors duration-200 cursor-pointer">办公资源</Link></li>
                <li><Link to="/about" className="text-sm text-secondary-200 hover:text-primary-300 transition-colors duration-200 cursor-pointer">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-bold text-background-50 mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-200">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-200">
                  <i className="ri-wechat-line text-primary-400"></i>
                  <span>微信：{siteInfo.wechat}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-200">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市海淀区中关村</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-secondary-300">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <p className="text-xs text-secondary-300">
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <span className="mx-2">|</span>
              <a href="#" className="hover:text-primary-300 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}